import { errorNotification, successNotification } from '../../../constants/Toast';
import SEQUENCE_REDUX_CONSTANT from '../../constants/sequenceReduxConstant/SequenceReduxConstant';
import SequenceService from '../../../services/sequence-service/SequenceService';

/**
 * Fetch all sequences
 */
export const fetchSequences = (params = {}) => {
    return (dispatch) => {
        dispatch({
            type: SEQUENCE_REDUX_CONSTANT.SET_LOADING_SEQUENCES,
            data: true,
        });

        SequenceService.getSequences(params)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    dispatch({
                        type: SEQUENCE_REDUX_CONSTANT.SET_SEQUENCES,
                        data: response.data.data,
                    });
                }
                dispatch({
                    type: SEQUENCE_REDUX_CONSTANT.SET_LOADING_SEQUENCES,
                    data: false,
                });
            })
            .catch((e) => {
                dispatch({
                    type: SEQUENCE_REDUX_CONSTANT.SET_LOADING_SEQUENCES,
                    data: false,
                });
                errorNotification(e?.response?.data?.message || 'Failed to fetch sequences');
            });
    };
};

/**
 * Fetch single sequence
 */
export const fetchSequence = (id) => {
    return (dispatch) => {
        dispatch({
            type: SEQUENCE_REDUX_CONSTANT.SET_LOADING_SEQUENCE,
            data: true,
        });

        SequenceService.getSequence(id)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    dispatch({
                        type: SEQUENCE_REDUX_CONSTANT.SET_CURRENT_SEQUENCE,
                        data: response.data.data,
                    });
                }
                dispatch({
                    type: SEQUENCE_REDUX_CONSTANT.SET_LOADING_SEQUENCE,
                    data: false,
                });
            })
            .catch((e) => {
                dispatch({
                    type: SEQUENCE_REDUX_CONSTANT.SET_LOADING_SEQUENCE,
                    data: false,
                });
                errorNotification(e?.response?.data?.message || 'Failed to fetch sequence');
            });
    };
};

/**
 * Create new sequence
 */
export const createSequence = (data, onSuccess) => {
    return (dispatch) => {
        dispatch({
            type: SEQUENCE_REDUX_CONSTANT.SET_CREATING_SEQUENCE,
            data: true,
        });

        SequenceService.createSequence(data)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    successNotification('Sequence created successfully!');
                    dispatch({
                        type: SEQUENCE_REDUX_CONSTANT.SET_CREATING_SEQUENCE,
                        data: false,
                    });
                    if (onSuccess) onSuccess(response.data.data);
                    dispatch(fetchSequences());
                }
            })
            .catch((e) => {
                dispatch({
                    type: SEQUENCE_REDUX_CONSTANT.SET_CREATING_SEQUENCE,
                    data: false,
                });
                errorNotification(e?.response?.data?.message || 'Failed to create sequence');
            });
    };
};

/**
 * Update sequence
 */
export const updateSequence = (id, data, onSuccess) => {
    return (dispatch) => {
        dispatch({
            type: SEQUENCE_REDUX_CONSTANT.SET_UPDATING_SEQUENCE,
            data: true,
        });

        SequenceService.updateSequence(id, data)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    successNotification('Sequence updated successfully!');
                    dispatch({
                        type: SEQUENCE_REDUX_CONSTANT.SET_UPDATING_SEQUENCE,
                        data: false,
                    });
                    if (onSuccess) onSuccess(response.data.data);
                    dispatch(fetchSequences());
                }
            })
            .catch((e) => {
                dispatch({
                    type: SEQUENCE_REDUX_CONSTANT.SET_UPDATING_SEQUENCE,
                    data: false,
                });
                errorNotification(e?.response?.data?.message || 'Failed to update sequence');
            });
    };
};

/**
 * Delete sequence
 */
export const deleteSequence = (id, onSuccess) => {
    return (dispatch) => {
        SequenceService.deleteSequence(id)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    successNotification('Sequence deleted successfully!');
                    if (onSuccess) onSuccess();
                    dispatch(fetchSequences());
                }
            })
            .catch((e) => {
                errorNotification(e?.response?.data?.message || 'Failed to delete sequence');
            });
    };
};

/**
 * Duplicate sequence
 */
export const duplicateSequence = (id, onSuccess) => {
    return (dispatch) => {
        SequenceService.duplicateSequence(id)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    successNotification('Sequence duplicated successfully!');
                    if (onSuccess) onSuccess(response.data.data);
                    dispatch(fetchSequences());
                }
            })
            .catch((e) => {
                errorNotification(e?.response?.data?.message || 'Failed to duplicate sequence');
            });
    };
};

/**
 * Enroll opportunities in sequence
 */
export const enrollOpportunities = (data, onSuccess) => {
    return (dispatch) => {
        dispatch({
            type: SEQUENCE_REDUX_CONSTANT.SET_ENROLLING,
            data: true,
        });

        SequenceService.enrollOpportunities(data)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    const results = response.data.data;
                    const successCount = results.successful?.length || 0;
                    const failedCount = results.failed?.length || 0;

                    if (successCount > 0) {
                        successNotification(`${successCount} lead(s) enrolled successfully!`);
                    }
                    if (failedCount > 0) {
                        errorNotification(`${failedCount} lead(s) could not be enrolled`);
                    }

                    dispatch({
                        type: SEQUENCE_REDUX_CONSTANT.SET_ENROLLING,
                        data: false,
                    });

                    if (onSuccess) onSuccess(results);
                }
            })
            .catch((e) => {
                dispatch({
                    type: SEQUENCE_REDUX_CONSTANT.SET_ENROLLING,
                    data: false,
                });
                errorNotification(e?.response?.data?.message || 'Failed to enroll leads');
            });
    };
};

/**
 * Get enrollment status
 */
export const getEnrollmentStatus = (opportunityId) => {
    return (dispatch) => {
        SequenceService.getEnrollmentStatus(opportunityId)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    dispatch({
                        type: SEQUENCE_REDUX_CONSTANT.SET_ENROLLMENT_STATUS,
                        data: response.data.data,
                    });
                }
            })
            .catch((e) => {
                console.error('Failed to get enrollment status:', e);
            });
    };
};

/**
 * Get sequence enrollments
 */
export const fetchSequenceEnrollments = (sequenceId) => {
    return (dispatch) => {
        console.log('🚀 Fetching enrollments for sequence:', sequenceId);
        dispatch({
            type: SEQUENCE_REDUX_CONSTANT.SET_LOADING_ENROLLMENTS,
            data: true,
        });

        SequenceService.getSequenceEnrollments(sequenceId)
            .then((response) => {
                console.log('✅ Enrollment API response:', response);
                console.log('📦 Response data:', response?.data);
                console.log('📝 Enrollments data to dispatch:', response?.data?.data);

                if (response?.data?.status === 'SUCCESS') {
                    dispatch({
                        type: SEQUENCE_REDUX_CONSTANT.SET_SEQUENCE_ENROLLMENTS,
                        data: response.data.data,
                    });
                } else {
                    console.warn('⚠️ Response status is not SUCCESS:', response?.data?.status);
                }
                dispatch({
                    type: SEQUENCE_REDUX_CONSTANT.SET_LOADING_ENROLLMENTS,
                    data: false,
                });
            })
            .catch((e) => {
                console.error('❌ Error fetching enrollments:', e);
                console.error('❌ Error response:', e?.response);
                dispatch({
                    type: SEQUENCE_REDUX_CONSTANT.SET_LOADING_ENROLLMENTS,
                    data: false,
                });
                errorNotification(e?.response?.data?.message || 'Failed to fetch enrollments');
            });
    };
};

/**
 * Clear current sequence
 */
export const clearCurrentSequence = () => {
    return {
        type: SEQUENCE_REDUX_CONSTANT.SET_CURRENT_SEQUENCE,
        data: null,
    };
};
